<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
            <!-- <h1>Toko<small>It's all start from here <i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1> -->
            <ol class="breadcrumb">
                <li><router-link to="/"> <i class="ti-home"></i></router-link></li>
                <li><a href="#">Laporan</a></li>
                <li class="active">Laporan</li>
            </ol>
        </section>
  
            <!-- Main content -->
            <section class="content">
               <!-- Basic Tables-->
                <div class="box">
                    <div class="box-header with-border">
                        <div class="pull-right">
                            <el-button type="success" icon="el-icon-plus" @click="addData()">Tambah Data</el-button>                            
                        </div>
                    </div>
                    <div class="box-body">
                          
                        <el-table 
                          :data="tableData6"
                          :span-method="objectSpanMethod1"
                          style="width: 100%; margin-top: 20px">
                          <el-table-column
                            prop="id"
                            label="ID"
                            width="180">
                            <template slot-scope="scope">
                              <el-button v-if="scope.row.id !== ''" size="mini" icon="el-icon-caret-bottom"></el-button>
                              <span> {{ scope.row.id }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="name"
                            label="Name">
                            <template slot-scope="scope">
                              <el-button v-if="scope.row.name !== ''" size="mini" icon="el-icon-caret-bottom"></el-button>
                              <span> {{ scope.row.name }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="amount1"
                            label="Amount 1">
                          </el-table-column>
                          <el-table-column
                            prop="amount2"
                            label="Amount 2">
                          </el-table-column>
                          <el-table-column
                            prop="amount3"
                            label="Amount 3">
                          </el-table-column>
                        </el-table>

                        <!-- <el-pagination
                          background
                          layout="prev, pager, next"
                          :total="tableData.length"
                          :page-size="page_size"
                          :current-page="current_page"
                          @current-change="handleCurrentChange" >
                        </el-pagination>
 -->

                    </div>
                </div>

              
                <!-- End of Basic Tables-->
                
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
    export default {
      name: 'LaporanCoba',
      data: function () {
        return {
          tableData6: [{
            id: '12987122',
            name: 'Tom',
            amount1: '234',
            amount2: '3.2',
            amount3: 10
          }, {
            id: '',
            name: 'Tom',
            amount1: '165',
            amount2: '4.43',
            amount3: 12
          }, {
            id: '',
            name: 'Tom',
            amount1: '324',
            amount2: '1.9',
            amount3: 9
          }, {
            id: '',
            name: 'Tom',
            amount1: '621',
            amount2: '2.2',
            amount3: 17
          }, {
            id: '',
            name: 'Tom',
            amount1: '539',
            amount2: '4.1',
            amount3: 15
          }, {
            id: '12987122',
            name: 'Tom',
            amount1: '234',
            amount2: '3.2',
            amount3: 10
          }, {
            id: '',
            name: 'Tom',
            amount1: '165',
            amount2: '4.43',
            amount3: 12
          }, {
            id: '',
            name: 'Tom',
            amount1: '324',
            amount2: '1.9',
            amount3: 9
          }, {
            id: '',
            name: 'Tom',
            amount1: '621',
            amount2: '2.2',
            amount3: 17
          }, {
            id: '',
            name: 'Tom',
            amount1: '539',
            amount2: '4.1',
            amount3: 15
          }]
        }
      },
      methods: {
        arraySpanMethod: function ({ row, column, rowIndex, columnIndex }) {
          if (rowIndex % 2 === 0) {
            if (columnIndex === 0) {
              return [1, 2]
            } else if (columnIndex === 1) {
              return [0, 0]
            }
          }
        },
        objectSpanMethod: function ({ row, column, rowIndex, columnIndex }) {
          if (columnIndex === 0) {
            if (rowIndex % 2 === 0) {
              return {
                rowspan: 2,
                colspan: 1
              }
            } else {
              return {
                rowspan: 0,
                colspan: 0
              }
            }
          }
        },
        objectSpanMethod1: function ({ row, column, rowIndex, columnIndex }) {
          if (rowIndex === 0 || rowIndex === 5) {
            if (columnIndex === 0) {
              return {
                rowspan: 1,
                colspan: 5
              }
            } else {
              return {
                rowspan: 0,
                colspan: 0
              }
            }
          } else if (rowIndex === 1 || rowIndex === 6) {
            if (columnIndex === 1) {
              return {
                rowspan: 1,
                colspan: 4
              }
            } else if (columnIndex === 0) {
              return {
                rowspan: 1,
                colspan: 1
              }
            } else {
              return {
                rowspan: 0,
                colspan: 0
              }
            }
          } else {
            if (columnIndex >= 2) {
              return {
                rowspan: 1,
                colspan: 1
              }
            } else if (columnIndex === 0) {
              return {
                rowspan: 1,
                colspan: 2
              }
            } else {
              return {
                rowspan: 0,
                colspan: 0
              }
            }
          }
        }
      },
      mounted () {
        // this.loadingModal = true
        // this.getData()
      }
    }
</script>



// WEBPACK FOOTER //
// LaporanCoba.vue?6b0f56c8